export const renderDivider = (): string =>
  `<table width="100%">
    <tr>
      <td height="1" style="height: 1px; background-color: #dddddd; font-size: 0; line-height: 0;"></td>
    </tr>
  </table>`;
